export const STATUSES = {
  APPROVED: 'approved',
  REJECTED: 'rejected',
  SUBMITTED: 'submitted',
  SENDBACK: 'sendback',
  END_FLOW: 'end_flow',
  PENDING_SUBMISSION: 'pending_submission',
};

/** Latest submission-stage progress awaiting review (immutable lifecycle). */
export const isReviewerActionableStatus = (status) => {
  if (status == null || typeof status !== 'string') return false;
  return status === STATUSES.SUBMITTED;
};
